export default "<div class=\"filter-container\"><csi-filter></csi-filter></div>\n"